<i class="pi pi-wrench devtools-menu" style="font-size: 1.25rem" (click)="devMenu.toggle($event)"></i>

<p-menu #devMenu [model]="developmentMenu()" [popup]="true" appendTo="body" />
